/**
 * Created by anthony on 2/13/15.
 */
var ismDateTime = angular.module('ismDateTime', []);
ismDateTime.directive('ismDateTime', function() {
    return {
        restrict: 'E',
        transclude: 'true',
        templateUrl: 'ism-angular-lib/directives/ismDateTime/ismDateTime.html?v=' + versionNo,
        scope: {
            date: '=',
            time: '=',
            minDate: '=?mindate',
            maxDate: '=?maxdate'
        },
        controller: function($scope, $element, $attrs)
        {
            
            $scope.showalldates = $attrs.showalldates;

            $scope.openDate = function() {
                $element.find(".ismdatepicker").datetimepicker('show');
            }

            $scope.openTime = function() {
                $element.find(".ismtimepicker").datetimepicker('show');
            }
        }
    };
});

ismDateTime.directive('ismDateTimeNoInput', function($rootScope) {
    return {
        restrict: 'E',
        transclude: 'true',
        templateUrl: 'ism-angular-lib/directives/ismDateTime/ismDateTimeNoInput.html?v=' + versionNo,
        scope: {
            date: '=',
            time: '='
        },
        controller: function($scope, $element, $attrs){
            $scope.showalldates = $attrs.showalldates;
            $scope.openDate2 = function() {
                $element.find(".ismdatepicker").datetimepicker('show');
            }

            $scope.switchTasks = function() {
                var d = $scope.date;
                if(d != ''){

                    var cleanedDate = d[6]+d[7]+d[8]+d[9]+"-"+d[0]+d[1]+"-"+d[3]+d[4];
                    $rootScope.$broadcast('showFutureTask',cleanedDate);
                }
            }
        }
    };
});


ismDateTime.directive('jqtimepicker', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element) {
            element.datetimepicker({
                datepicker:false,
                format:'H:i',
                formatTime:'h:i a',
                step:15
            });


        }
    };
});

ismDateTime.directive('jqdatepicker', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, element, attrs) {

  
            if(attrs.showalldates){

                element.datetimepicker({
                    timepicker:false,
                    format:'m/d/Y',
                    formatDate:'m/d/Y'
                });
            }else if(scope.minDate != undefined && scope.maxDate == undefined){

                element.datetimepicker({
                    timepicker:false,
                    format:'m/d/Y',
                    formatDate:'m/d/Y',
                    minDate: scope.minDate
                });
            }else if(scope.minDate == undefined && scope.maxDate != undefined){

                element.datetimepicker({
                    timepicker:false,
                    format:'m/d/Y',
                    formatDate:'m/d/Y',
                    maxDate: scope.maxDate
                });
            }else if(scope.minDate != undefined && scope.maxDate != undefined){

                //If the max date is changed this will 
                scope.$watch('maxDate', function(newValue, oldValue){

                    scope.maxDate = newValue;
                    element.datetimepicker({
                        timepicker:false,
                        format:'m/d/Y',
                        formatDate:'m/d/Y',
                        maxDate: scope.maxDate,
                        minDate: scope.minDate
                    });
                });

            }else{

                element.datetimepicker({
                    timepicker:false,
                    format:'m/d/Y',
                    formatDate:'m/d/Y',
                    minDate: 0
                });
            }
        }
    };
});